/**
 * Header behaviour: wishlist button opens mini-cart on wishlist tab.
 * Opens the drawer (if closed) then dispatches theme:cart:openWishlist
 * so cart-drawer-wishlist switches to the wishlist tab.
 * Uses event delegation so it works regardless of render timing.
 */
export function initWishlistHeaderButton() {
  if (window.__wishlistHeaderButtonBound) return;
  window.__wishlistHeaderButtonBound = true;

  document.addEventListener('click', (e) => {
    const wishlistButton = e.target.closest('[data-wishlist-header-button]');
    if (!wishlistButton) return;

    e.preventDefault();

    const cartDrawer = document.querySelector('[data-cart-drawer]');
    if (cartDrawer?.openCartDrawer) {
      cartDrawer.openCartDrawer();
    }

    document.dispatchEvent(
      new CustomEvent('theme:cart:openWishlist', { bubbles: true })
    );
  });
}
